export default __webpack_public_path__ + "static/media/failure.b2842486.svg";